// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"65486967","233":"0e8dbb16","369":"7b63b2a5","777":"d85915b3","936":"7e388a52"}[chunkId] + ".js";
};